import { type PropsWithChildren } from "react";
import { useQuery } from "@tanstack/react-query";
import { MsalAuthenticationTemplate, MsalProvider } from "@azure/msal-react";
import { InteractionType } from "@azure/msal-browser";
import LoadingPane from "../components/LoadingPane";
import { getRuntimeSettingsQuery } from "@/api/runtimeSettings/getRuntimeSettings";
import { getMsalInstance, loginRequest } from "@/security/msal";
import AuthenticationErrorPane from "@/components/AuthErrorPane";

export const AuthProvider = ({ children }: PropsWithChildren) => {
  const { data, isPending, isError } = useQuery(getRuntimeSettingsQuery());

  if (isPending) {
    return <LoadingPane />;
  } else if (isError) {
    return <div>Error loading runtime settings.</div>;
  }
  const msalInstance = getMsalInstance(data.clientId, data.tenantId);

  return (
    <MsalProvider instance={msalInstance}>
      <MsalAuthenticationTemplate
        interactionType={InteractionType.Redirect}
        authenticationRequest={loginRequest}
        errorComponent={AuthenticationErrorPane}
        loadingComponent={LoadingPane}
      >
        {children}
      </MsalAuthenticationTemplate>
    </MsalProvider>
  );
};
